module.exports = __webpack_public_path__ + "h5assets/img/collabs-level-company@2x.a134358.png";